import type { VolunteerOrgActivity } from "@entities";
import {
  volunteerOrgActivityRepo,
} from "@repositories";

export async function syncVolunteerOrgActivities(
  volunteerOrganizationId: string,
  domainIds: string[],
) {
  const existing = await volunteerOrgActivityRepo.find({
    where: { volunteerOrganizationId },
  });
  const uniqueIds = [...new Set(domainIds)];
  await Promise.all(
    existing
      .filter((row) => !uniqueIds.includes(row.domainId))
      .map((row) => volunteerOrgActivityRepo.delete(row.id)),
  );
  await Promise.all(
    uniqueIds
      .filter((domainId) => !existing.some((row) => row.domainId === domainId))
      .map((domainId) =>
        volunteerOrgActivityRepo.insert({
          volunteerOrganizationId,
          domainId,
        }),
      ),
  );
}

export function activityDomainIds(activities?: VolunteerOrgActivity[] | null) {
  return (activities ?? []).map((row) => row.domainId);
}
